import { putRole } from '../api/putRole';

export const setPutRole = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putRole(params);

            alert('Сохранено')
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}